var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResturantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 7L21.721 0H2.279L0 7C0 8.474 0.81 9.75 2 10.444V18H0V21C0 22.654 1.346 24 3 24H21C22.654 24 24 22.654 24 21V18H22V10.444C23.19 9.75 24 8.474 24 7ZM3.721 2H7V5H9V2H15V5H17V2H20.279L21.995 7.146C21.92 8.181 21.054 9 20 9H19C17.897 9 17 8.103 17 7H15C15 8.103 14.103 9 13 9H11C9.897 9 9 8.103 9 7H7C7 8.103 6.103 9 5 9H4C2.946 9 2.08 8.181 2.005 7.146L3.721 2ZM22 21C22 21.551 21.552 22 21 22H3C2.448 22 2 21.551 2 21V20H8.086L9.086 21H14.914L15.914 20H22V21ZM20 18H15.086L14.086 19H9.914L8.914 18H4V11H5C6.201 11 7.266 10.458 8 9.618C8.734 10.458 9.799 11 11 11H13C14.201 11 15.266 10.458 16 9.618C16.734 10.458 17.799 11 19 11H20V18Z",
    fill: "#FC981B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_1538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResturantIcon);
export default __webpack_public_path__ + "static/media/Resturant_icon.f8de7c42d78f123b00ccfd371498ae66.svg";
export { ForwardRef as ReactComponent };